import { Profile } from '../types/Profile';
import { CLASS_POSITION } from 'edrolo/domains/profile';

export const getIsTeacherView = (
  profile: Profile,
  classId: ClassId,
  overriddenClassPosition: string
) => {
  const isStaff: boolean = profile.is_staff || false;
  const profileClassPosition =
    profile.school_classes[classId]?.position || CLASS_POSITION.STUDENT;

  const classPosition =
    isStaff && overriddenClassPosition
      ? overriddenClassPosition
      : profileClassPosition;

  return (
    classPosition === CLASS_POSITION.TEACHER ||
    classPosition === CLASS_POSITION.SUPERVISOR
  );
};
